/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 7/29/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
const LoadStyle = {
  install: function(Vue) {
    Vue.loadStyle = Vue.prototype.$loadStyle = function(href) {
      return new Promise(function(resolve, reject) {
        let shouldAppend = false;
        let el = document.querySelector('link[href="' + href + '"]');
        if (!el) {
          el = document.createElement("link");
          el.rel = "stylesheet";
          el.href = href;
          shouldAppend = true;
        } else if (el.hasAttribute("data-loaded")) {
          resolve(el);
          return;
        }

        el.addEventListener("error", reject);
        el.addEventListener("abort", reject);
        el.addEventListener("load", function loadStyleHandler() {
          el.setAttribute("data-loaded", "true");
          resolve(el);
        });

        if (shouldAppend) document.head.appendChild(el);
      });
    };

    Vue.unloadStyle = Vue.prototype.$unloadStyle = function(href) {
      return new Promise(function(resolve, reject) {
        const el = document.querySelector('link[href="' + href + '"]');

        if (!el) {
          reject();
          return;
        }

        document.head.removeChild(el);

        resolve();
      });
    };
  }
};

export default LoadStyle;
